export default __webpack_public_path__ + "static/4-7ddf12952345533642453035fb3395a6.jpg";